// extracted by mini-css-extract-plugin
export var button = "delete-button-module--button--6aca7";
export var container = "delete-button-module--container--fad80";
export var trash = "delete-button-module--trash--f4507";